export const validatePan = (pan: string): string => {
  const length = pan.length;
  if (length === 0) return ''; 
  if (length >= 1 && !/^[A-Za-z]{1}/.test(pan)) {
    return 'The first character must be an alphabet';
  }
  if (length >= 2 && !/^[A-Za-z]{2}/.test(pan)) {
    return 'The second character must be an alphabet';
  }
  if (length >= 3 && !/^[A-Za-z]{3}/.test(pan)) {
    return 'The third character must be an alphabet';
  }
  if (length >= 4 && !/^[A-Za-z]{4}/.test(pan)) {
    return 'The fourth character must be an alphabet';
  }
  if (length >= 5 && !/^[A-Za-z]{5}/.test(pan)) {
    return 'The fifth character must be an alphabet';
  }
  if (length >= 6 && !/^[A-Za-z]{5}\d{1}/.test(pan)) {
    return 'The sixth character must be a digit';
  }
  if (length >= 7 && !/^[A-Za-z]{5}\d{2}/.test(pan)) {
    return 'The seventh character must be a digit';
  }
  if (length >= 8 && !/^[A-Za-z]{5}\d{3}/.test(pan)) {
    return 'The eighth character must be a digit';
  }
  if (length >= 9 && !/^[A-Za-z]{5}\d{4}/.test(pan)) {
    return 'The ninth character must be a digit';
  }
  if (length >= 10 && !/^[A-Za-z]{5}\d{4}[A-Za-z]{1}/.test(pan)) {
    return 'The tenth character must be an alphabet';
  }
  if (length > 10) {
    return 'PAN must be exactly 10 characters';
  }
  return ''; 
};
